import React, { useState } from "react";
import {
  Calendar as BigCalendar,
  Views,
  momentLocalizer,
} from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import {
  CalendarWrapper,
  CalenderHead,
  HeadText,
  HeadBottom,
  HeadBottomContainer,
  CalendarBottom,
  NavigateButtons,
  Button,
  RemainingSlotsText,
  HeadBottomDescription,
} from "./style";
import CustomToolbar from "./CustomToolBar";
import moment from "moment";

const localizer = momentLocalizer(moment);

const CalenderAddEvents = ({ events, setEvents }) => {
  const MAX_EVENTS = 10;
  const [slot, setSlot] = useState(60);
  const remainingSlots = MAX_EVENTS - events.length;
  const [currentDate, setCurrentDate] = useState(new Date());
  const [currentView, setCurrentView] = useState(Views.WEEK);

  const CustomMonthCell = ({ date, children }) => {
    if (!date) return <>{children}</>;
    const currentMonth = new Date().getMonth();
    const cellMonth = date.getMonth();
    const isCurrentMonth = cellMonth === currentMonth;

    return (
      <div
        style={{
          color: isCurrentMonth ? "inherit" : "#ccc",
          pointerEvents: isCurrentMonth ? "auto" : "none",
          opacity: isCurrentMonth ? 1 : 0.5,
          textAlign: "center",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {children}
        <div
          style={{
            width: "6px",
            height: "6px",
            backgroundColor: isCurrentMonth ? "#4A90E2" : "transparent",
            borderRadius: "50%",
            margin: "0 auto",
          }}
        ></div>
      </div>
    );
  };

  const handleSelectSlot = ({ start, end }) => {
    const now = new Date();
    if (events.length >= MAX_EVENTS) return;
    if (start < now) return;
    const newEvent = {
      id: events.length + 1,
      start,
      end,
      slot: slot,
    };

    setEvents((prevEvents) => [...prevEvents, newEvent]);
  };

  const handleUnselectSlot = (event) => {
    setEvents((prevEvents) =>
      prevEvents.filter(
        (e) =>
          new Date(e.start).getTime() !== new Date(event.start).getTime() ||
          new Date(e.end).getTime() !== new Date(event.end).getTime()
      )
    );
  };

  const handleNavigate = (action) => {
    let newDate = new Date(currentDate);

    if (currentView === Views.WEEK) {
      if (action === "PREV") {
        newDate.setDate(newDate.getDate() - 7);
      } else if (action === "NEXT") {
        newDate.setDate(newDate.getDate() + 7);
      }
    } else if (currentView === Views.MONTH) {
      if (action === "PREV") {
        newDate.setMonth(newDate.getMonth() - 1);
      } else if (action === "NEXT") {
        newDate.setMonth(newDate.getMonth() + 1);
      }
    }

    setCurrentDate(newDate);
  };
  const handleViewChange = (view) => {
    setCurrentView(view);
  };

  return (
    <>
      <CalendarWrapper>
        <CalenderHead>
          <HeadText>Duration (Select one)</HeadText>
          <HeadBottomContainer>
            <HeadBottom isSlotActive={slot === 30} onClick={() => setSlot(30)}>
              30 min
            </HeadBottom>
            <HeadBottom isSlotActive={slot === 60} onClick={() => setSlot(60)}>
              60 min
            </HeadBottom>
          </HeadBottomContainer>
          <HeadBottomDescription>
            Please indicate up to 10 different dates and times that you are
            available to meet
          </HeadBottomDescription>
        </CalenderHead>
        <BigCalendar
          localizer={localizer}
          events={events}
          date={currentDate}
          onView={handleViewChange}
          onNavigate={(newDate) => setCurrentDate(newDate)}
          selectable={events.length < MAX_EVENTS}
          defaultView={Views.WEEK}
          views={["week"]}
          style={{ height: "580px" }}
          components={{
            // dateCellWrapper: CustomMonthCell,
            toolbar: CustomToolbar,
          }}
          slotPropGetter={(date) => {
            const now = new Date();
            const isPast = date < now;

            return {
              style: {
                pointerEvents: isPast ? "none" : "auto",
              },
            };
          }}
          onSelectSlot={handleSelectSlot}
          onSelectEvent={handleUnselectSlot}
          allDayAccessor={null}
          step={slot}
          timeslots={1}
        />
        <CalendarBottom>
          <RemainingSlotsText>
            {remainingSlots} options remaining
          </RemainingSlotsText>
          <NavigateButtons>
            <Button onClick={() => handleNavigate("PREV")}>
              {"<"} Previous
            </Button>
            <Button onClick={() => handleNavigate("NEXT")}>Next {">"}</Button>
          </NavigateButtons>
        </CalendarBottom>
      </CalendarWrapper>
    </>
  );
};

export default CalenderAddEvents;
